







import {
  defineComponent, ref, useFetch,
} from '@nuxtjs/composition-api';
import ProductsCarousel from '~/modules/catalog/product/components/ProductsCarousel.vue';
import useCrosssellProducts from '~/modules/catalog/product/composables/useCrosssellProducts';
import { usePageStore } from '~/stores/page';

export default defineComponent({
  name: 'CrosssellProducts',
  components: {
    ProductsCarousel,
  },
  setup() {
    const { routeData } = usePageStore();
    const { search, loading } = useCrosssellProducts();
    const products = ref([]);

    useFetch(async () => {
      const baseSearchQuery = {
        filter: {
          sku: {
            eq: routeData.sku,
          },
        },
      };
      products.value = await search(baseSearchQuery);
    });

    return {
      products,
      loading,
    };
  },
});
